import { toPascalCase } from "src/lib/utils/stringUtils";
import { Chip } from "../../basics";
import { IInvestorProfileChipProps } from "./types";
import { useTheme } from "@mui/material";
import { translation } from "./translationPT";

const InvestorProfileChip = (props: IInvestorProfileChipProps) => {
    const theme = useTheme();
    const p = props.profile;

    const bg = {
        balanced: theme.palette.primary.main,
        conservative: (theme as any).palette.primary?.lighter ?? theme.palette.primary.light,
        sophisticated: (theme as any).palette.primary.darker,
    }[p];

    const text = {
        balanced: (theme as any).palette.neutral?.darkest ?? theme.palette.text.primary,
        conservative: (theme as any).palette.neutral?.darkest ?? theme.palette.text.primary,
        sophisticated: (theme as any).palette.neutral?.lightest ?? theme.palette.text.primary,
    }[p];

    return (
        <Chip
            label={toPascalCase(translation[p])}
            sx={{
                backgroundColor: bg,
                color: text,
                // ensure the inner label inherits the color
                '& .MuiChip-label': {
                    color: 'inherit !important'
                },
                // if the label uses a Typography component, make it inherit as well
                '& .MuiChip-label .MuiTypography-root': {
                    color: 'inherit !important',
                    fontWeight: '500'
                }
            }}
        />
    )
}

export { InvestorProfileChip }
